/* istanbul ignore file */
import FavoritesLimitReachedDialog from '@ms/yammer-web-components/dist/group/FavoritesLimitReachedDialog';
import { LoadableUsagePolicyDialog } from '@ms/yammer-web-components/dist/usagePolicy/UsagePolicyDialog';
import type { FC } from 'react';
import React from 'react';

import FirstRunExperience from '../FirstRunExperience';

const Dialogs: FC = () => (
  <>
    <FirstRunExperience />
    <LoadableUsagePolicyDialog />
    <FavoritesLimitReachedDialog />
  </>
);

export default Dialogs;
